import React from "react"
import {IconCircleDashedCheck} from "@tabler/icons-react"
import {twMerge} from "tailwind-merge"
import {ENABLE_STUBS} from "@/config/stubConfig"

interface StubIndicatorProps {
  featureName?: string
  className?: string
  show?: boolean
}

/**
 * Common indicator component to show when stub data is being used
 */
export const StubIndicator: React.FC<StubIndicatorProps> = ({
  featureName = "",
  className = "",
  show = true,
}) => {
  if (!ENABLE_STUBS || !show) return null

  const label = featureName
    ? `Using ${featureName} stub data`
    : "Using stub data"

  return (
    <div
      className={twMerge(
        `flex w-fit flex-row items-center gap-1 rounded-xl border border-black/5 bg-white p-1`,
        className
      )}
    >
      <IconCircleDashedCheck className="h-4 w-4" color="orange" />
      <div className="flex flex-row items-center gap-2">
        <p className="text-sm font-medium">{label}</p>
      </div>
    </div>
  )
}
